module.exports = __webpack_public_path__ + "img/ALL-COVER.07f5ec10.png";